
<div class="grid-card" style="height:600px">
    <div class="grid-header-row">
        <div class="grid-header">
            <h1>{{ selectedRequest?.title }}</h1>
        </div>
        <div class="grid-menu">
            <button mat-icon-button *ngIf="!hideMenu" [matMenuTriggerFor]="tableMenu" class="card-action-btn" type="button"
                aria-label="Configure table source">
                <mat-icon>tune</mat-icon>
            </button>

            <!-- IMPORTANT: mat-menu lives at root level (no *ngIf/*ngFor wrappers) -->
            <mat-menu #tableMenu="matMenu">
                <ng-container *ngIf="tableOptionMenu?.length; else noTableItems">
                    <button mat-menu-item *ngFor="let option of tableOptionMenu" (click)="selectRequest(option)">
                        <mat-icon class="mr-2">{{ option.icon }}</mat-icon>
                        <span>{{ option.title }}</span>
                    </button>
                </ng-container>

                <ng-template #noTableItems>
                    <button mat-menu-item disabled>No sources</button>
                </ng-template>
            </mat-menu>

        </div>
    </div>
    <div class="main-workspace-content">
        <div class="main-view-container">
            <div class="workspace-container">
                <disco-tab-provider *ngIf="selectedRequest" [config]="{appId: selectedRequest.appId, tabId: selectedRequest.tabId}"
                    (context)="setTabContext($event)" [emitOnChanges]="true">
                    <ng-template let-tabContext>
                        <disco-report *ngIf="tabContext" [queryService]="selectedRequest.queryService"
                            [requestId]="selectedRequest.requestId">
                            <ng-template let-reportContext>
                                <div class="hover-area flex p-1 flex-col flex-auto">
                                    <div *ngIf="isTableLoading" class="loading-state" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 500px;">
                                        <mat-spinner [diameter]="50"></mat-spinner>
                                        <p style="margin-top: 16px;">Loading table data...</p>
                                    </div>
                                    <reports-view *ngIf="!isTableLoading" [height]="'600px'" [hideEditColumn]="true">
                                    </reports-view>
                                </div>
                            </ng-template>
                        </disco-report>
                    </ng-template>
                </disco-tab-provider>
            </div>
        </div>
    </div>
</div>
